import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import Welcome from "./pages/Welcome";
import Onboarding from "./pages/Onboarding";
import Access from "./pages/Access";
import Panel from "./pages/Panel";
import Support from "./pages/Support";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminForgot from "./pages/AdminForgot";
import AdminReset from "./pages/AdminReset";
import VendorLogin from "./pages/VendorLogin";
import VendorRegister from "./pages/VendorRegister";
import VendorDashboard from "./pages/VendorDashboard";
import VendorAuthCallback from "./pages/VendorAuthCallback";
import VendorLanding from "./pages/VendorLanding";
import PaymentReturn from "./pages/PaymentReturn";
import PaymentCancel from "./pages/PaymentCancel";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/formulario" element={<Navigate to="/onboarding" replace />} />
        <Route path="/solucion" element={<Navigate to="/onboarding" replace />} />

        <Route path="/acceso" element={<Access />} />
        <Route path="/panel" element={<Panel />} />
        <Route path="/soporte" element={<Support />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/privacidad" element={<Privacy />} />

        <Route path="/vendedores" element={<VendorLanding />} />
        <Route path="/embajadores" element={<VendorLanding />} />
        <Route path="/vendedores/login" element={<VendorLogin />} />
        <Route path="/vendedores/registro" element={<VendorRegister />} />
        <Route path="/vendedores/panel" element={<VendorDashboard />} />
        <Route path="/vendedores/auth-callback" element={<VendorAuthCallback />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/forgot" element={<AdminForgot />} />
        <Route path="/admin/reset" element={<AdminReset />} />
        <Route path="/admin" element={<AdminDashboard />} />

        <Route path="/pago/retorno" element={<PaymentReturn />} />
        <Route path="/pago/cancelado" element={<PaymentCancel />} />
      </Routes>
      <Toaster position="top-center" richColors closeButton />
    </BrowserRouter>
  );
}
